import { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getProjectDetails,
  getCostCodesByProjectId,
  updateCostCodes,
} from "../API";
import ArrowLeft from "../assets/images/left-arrow.png";
import { toast } from "react-toastify";
import Loader from "./Loader";
import MergeWhite from "../assets/images/merge-white.png";
import MergeProjectModal from "../components/MergeProjectModal";

const ProjectDetails = () => {
  const [projectDetails, setProjectDetails] = useState();
  const [costCodes, setCostCodes] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const param = useParams();

  const costCodeTableHeadings = ["Select", "Cost code", "Description", "Task"];
  const projectInfoFields = [
    {
      label: "Project id",
      value: projectDetails?.acumatica_project_id,
    },
    {
      label: "Description",
      value: projectDetails?.description,
    },
    {
      label: "Status",
      value: projectDetails?.status,
    },

    {
      label: "Union local",
      value: projectDetails?.union_local?.name,
    },
  ];

  const fetchProjectDetails = useCallback(async () => {
    await getProjectDetails(param?.id)
      .then((res) => {
        if (res.status === 200) {
          setProjectDetails(res?.data);
        }
        setLoading(false);
      })
      .catch((err) => console.log("error occured in getProjectDetails", err));
  }, [param?.id]);

  const fetchCostCodes = useCallback(async () => {
    await getCostCodesByProjectId(param?.id).then((res) => {
      if (res?.data?.length > 0) {
        setCostCodes(res?.data?.sort((a, b) => a?.id - b?.id));
      }
    });
    setLoading(false);
  }, [param?.id]);

  const onRowSelection = async (id, event) => {
    if (id) {
      const checked = event.target.checked;
      const payload = {
        is_default: checked,
      };
      await updateCostCodes(id, payload).then((res) => {
        fetchCostCodes();
        toast.success("Cost code updated");
      });
    }
  };

  useEffect(() => {
    fetchProjectDetails();
    fetchCostCodes();
  }, [fetchCostCodes, fetchProjectDetails]);

  return (
    <div className="crew-mgmt project-details-page">
      <div className="project-details-toolbar">
        <button
          className="btn btn-primary back-btn project-details-back-btn"
          onClick={() => navigate(-1)}
          type="button"
        >
          <img src={ArrowLeft} alt="Back" />
        </button>
        <h1 className="title project-details-title">Project Details</h1>
        <div className="project-details-toolbar__actions">
          {projectDetails?.type === "webtime" && (
            <button
              className="primary-btn add-temp-project project-details-merge-btn"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#mergeProjectModal"
            >
              <img className="merge-logo-styles" src={MergeWhite} alt="" />
              Merge Project
            </button>
          )}
        </div>
      </div>
      {!loading ? (
        <>
          <div className="crew-mgmt-card project-details-summary-card">
            <div className="project-details-summary-grid">

                {projectInfoFields.slice(0, 4).map((field) => (
                <div className="project-details-summary-column" key={field.label}>
                  <label className="project-details-field__label">
                      {field.label}
                    </label>
                    <div className="project-details-field__control">
                      <input
                        value={field.value || ""}
                        disabled
                        name={field.label}
                        type="text"
                        className="form-control project-details-field__input"
                      />
                    </div>
                </div>

                ))}


            </div>
          </div>
          <div className="project-details-cost-code">
            <h4 className="title project-details-section-title">Cost code</h4>
            <div className="table-responsive cost-code-table project-details-table-wrap">
              <table className="table table-bordered project-details-table">
                <thead>
                  <tr>
                    {costCodeTableHeadings.map((item, key) => (
                      <th scope="col" key={key}>
                        {item}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {costCodes && costCodes.length > 0 ? (
                    costCodes.map((costCode, key) => {
                      return (
                        <tr key={key}>
                          <td className="project-details-table__select">
                            <input
                              name="user"
                              onChange={(event) => {
                                onRowSelection(costCode?.id, event);
                              }}
                              type="checkbox"
                              checked={costCode?.is_default}
                              className="project-details-table__checkbox"
                            />
                          </td>
                          <td className="project-details-table__cost-code">
                            {costCode?.cost_code}
                          </td>
                          <td>{costCode?.description}</td>
                          <td>
                            {costCode?.project_task?.description
                              ? costCode?.project_task?.description
                              : "NA"}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    !loading && (
                      <tr>
                        <td colSpan={costCodeTableHeadings.length}>
                          No data found
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <MergeProjectModal projectId={param?.id} />
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default ProjectDetails;
